import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { logger, supportsNativeFetch, fill, GLOBAL_OBJ, addExceptionMechanism } from '@sentry/utils';
/** HTTPClient integration creates events for failed client side HTTP requests. */

var HttpClient = /*#__PURE__*/function () {
  _createClass(HttpClient, [{
    key: "__init",

    /**
     * @inheritDoc
     */
    value: function __init() {
      this.name = HttpClient.id;
    }
    /**
     * Returns current hub.
     */

    /**
     * @inheritDoc
     *
     * @param options
     */

  }], [{
    key: "__initStatic",

    /**
     * @inheritDoc
     */
    value: function __initStatic() {
      this.id = 'HttpClient';
    }
  }]);

  function HttpClient(options) {
    _classCallCheck(this, HttpClient);

    ;

    HttpClient.prototype.__init.call(this);

    this._options = _objectSpread({
      failedRequestStatusCodes: [[500, 599]],
      failedRequestTargets: [/.*/]
    }, options);
  }
  /**
   * @inheritDoc
   *
   * @param options
   */


  _createClass(HttpClient, [{
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      this._getCurrentHub = getCurrentHub;

      this._wrapFetch();

      this._wrapXHR();
    }
    /**
     * Interceptor function for fetch requests
     *
     * @param requestInfo The Fetch API request info
     * @param response The Fetch API response
     * @param requestInit The request init object
     */

  }, {
    key: "_fetchResponseHandler",
    value: function _fetchResponseHandler(requestInfo, response, requestInit) {
      var _this = this;

      if (this._getCurrentHub && this._shouldCaptureResponse(response.status, response.url)) {
        var request = new Request(requestInfo, requestInit);

        var hub = this._getCurrentHub();

        var requestHeaders, responseHeaders, requestCookies, responseCookies;

        if (hub.shouldSendDefaultPii()) {
          var _map = [{
            cookieHeader: 'Cookie',
            obj: request
          }, {
            cookieHeader: 'Set-Cookie',
            obj: response
          }].map(function (_ref) {
            var cookieHeader = _ref.cookieHeader,
                obj = _ref.obj;

            var headers = _this._extractFetchHeaders(obj.headers);

            var cookies;

            try {
              var cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;

              if (cookieString) {
                cookies = _this._parseCookieString(cookieString);
              }
            } catch (e) {
              (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log("Could not extract cookies from header ".concat(cookieHeader));
            }

            return {
              headers: headers,
              cookies: cookies
            };
          });

          var _map2 = _slicedToArray(_map, 2);

          var _map2$ = _map2[0];
          requestHeaders = _map2$.headers;
          requestCookies = _map2$.cookies;
          var _map2$2 = _map2[1];
          responseHeaders = _map2$2.headers;
          responseCookies = _map2$2.cookies;
        }

        var event = this._createEvent({
          url: request.url,
          method: request.method,
          status: response.status,
          requestHeaders: requestHeaders,
          responseHeaders: responseHeaders,
          requestCookies: requestCookies,
          responseCookies: responseCookies
        });

        hub.captureEvent(event);
      }
    }
    /**
     * Interceptor function for XHR requests
     *
     * @param xhr The XHR request
     * @param method The HTTP method
     * @param headers The HTTP headers
     */

  }, {
    key: "_xhrResponseHandler",
    value: function _xhrResponseHandler(xhr, method, headers) {
      if (this._getCurrentHub && this._shouldCaptureResponse(xhr.status, xhr.responseURL)) {
        var requestHeaders, responseCookies, responseHeaders;

        var hub = this._getCurrentHub();

        if (hub.shouldSendDefaultPii()) {
          try {
            var cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;

            if (cookieString) {
              responseCookies = this._parseCookieString(cookieString);
            }
          } catch (e) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Could not extract cookies from response headers');
          }

          try {
            responseHeaders = this._getXHRResponseHeaders(xhr);
          } catch (e) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Could not extract headers from response');
          }

          requestHeaders = headers;
        }

        var event = this._createEvent({
          url: xhr.responseURL,
          method: method,
          status: xhr.status,
          requestHeaders: requestHeaders,
          // Can't access request cookies from XHR
          responseHeaders: responseHeaders,
          responseCookies: responseCookies
        });

        hub.captureEvent(event);
      }
    }
    /**
     * Extracts response size from `Content-Length` header when possible
     *
     * @param headers
     * @returns The response size in bytes or undefined
     */

  }, {
    key: "_getResponseSizeFromHeaders",
    value: function _getResponseSizeFromHeaders(headers) {
      if (headers) {
        var contentLength = headers['Content-Length'] || headers['content-length'];

        if (contentLength) {
          return parseInt(contentLength, 10);
        }
      }

      return undefined;
    }
    /**
     * Creates an object containing cookies from the given cookie string
     *
     * @param cookieString The cookie string to parse
     * @returns The parsed cookies
     */

  }, {
    key: "_parseCookieString",
    value: function _parseCookieString(cookieString) {
      return cookieString.split('; ').reduce(function (acc, cookie) {
        var _cookie$split = cookie.split('='),
            _cookie$split2 = _slicedToArray(_cookie$split, 2),
            key = _cookie$split2[0],
            value = _cookie$split2[1];

        acc[key] = value;
        return acc;
      }, {});
    }
    /**
     * Extracts the headers as an object from the given Fetch API request or response object
     *
     * @param headers The headers to extract
     * @returns The extracted headers as an object
     */

  }, {
    key: "_extractFetchHeaders",
    value: function _extractFetchHeaders(headers) {
      var result = {};
      headers.forEach(function (value, key) {
        result[key] = value;
      });
      return result;
    }
    /**
     * Extracts the response headers as an object from the given XHR object
     *
     * @param xhr The XHR object to extract the response headers from
     * @returns The response headers as an object
     */

  }, {
    key: "_getXHRResponseHeaders",
    value: function _getXHRResponseHeaders(xhr) {
      var headers = xhr.getAllResponseHeaders();

      if (!headers) {
        return {};
      }

      return headers.split('\r\n').reduce(function (acc, line) {
        var _line$split = line.split(': '),
            _line$split2 = _slicedToArray(_line$split, 2),
            key = _line$split2[0],
            value = _line$split2[1];

        acc[key] = value;
        return acc;
      }, {});
    }
    /**
     * Checks if the given target url is in the given list of targets
     *
     * @param target The target url to check
     * @returns true if the target url is in the given list of targets, false otherwise
     */

  }, {
    key: "_isInGivenRequestTargets",
    value: function _isInGivenRequestTargets(target) {
      if (!this._options.failedRequestTargets) {
        return false;
      }

      return this._options.failedRequestTargets.some(function (givenRequestTarget) {
        if (typeof givenRequestTarget === 'string') {
          return target.includes(givenRequestTarget);
        }

        return givenRequestTarget.test(target);
      });
    }
    /**
     * Checks if the given status code is in the given range
     *
     * @param status The status code to check
     * @returns true if the status code is in the given range, false otherwise
     */

  }, {
    key: "_isInGivenStatusRanges",
    value: function _isInGivenStatusRanges(status) {
      if (!this._options.failedRequestStatusCodes) {
        return false;
      }

      return this._options.failedRequestStatusCodes.some(function (range) {
        if (typeof range === 'number') {
          return range === status;
        }

        return status >= range[0] && status <= range[1];
      });
    }
    /**
     * Wraps `fetch` function to capture request and response data
     */

  }, {
    key: "_wrapFetch",
    value: function _wrapFetch() {
      if (!supportsNativeFetch()) {
        return;
      } // eslint-disable-next-line @typescript-eslint/no-this-alias


      var self = this;
      fill(GLOBAL_OBJ, 'fetch', function (originalFetch) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var requestInfo = args[0],
              requestInit = args[1];
          var responsePromise = originalFetch.apply(this, args);
          responsePromise.then(function (response) {
            self._fetchResponseHandler(requestInfo, response, requestInit);

            return response;
          }).catch(function (error) {
            throw error;
          });
          return responsePromise;
        };
      });
    }
    /**
     * Wraps XMLHttpRequest to capture request and response data
     */

  }, {
    key: "_wrapXHR",
    value: function _wrapXHR() {
      if (!('XMLHttpRequest' in GLOBAL_OBJ)) {
        return;
      } // eslint-disable-next-line @typescript-eslint/no-this-alias


      var self = this;
      fill(XMLHttpRequest.prototype, 'open', function (originalOpen) {
        return function () {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          var xhr = this;

          for (var _len2 = arguments.length, openArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            openArgs[_key2] = arguments[_key2];
          }

          var method = openArgs[0];
          var headers = {}; // Intercepting `setRequestHeader` to access the request headers of XHR instance.
          // This will only work for user/library defined headers, not for the default/browser-assigned headers.
          // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.

          fill(xhr, 'setRequestHeader', // eslint-disable-next-line @typescript-eslint/ban-types
          function (originalSetRequestHeader) {
            return function () {
              for (var _len3 = arguments.length, setRequestHeaderArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                setRequestHeaderArgs[_key3] = arguments[_key3];
              }

              var header = setRequestHeaderArgs[0],
                  value = setRequestHeaderArgs[1];
              headers[header] = value;
              return originalSetRequestHeader.apply(xhr, setRequestHeaderArgs);
            };
          }); // eslint-disable-next-line @typescript-eslint/ban-types

          fill(xhr, 'onloadend', function (original) {
            return function () {
              try {
                self._xhrResponseHandler(xhr, method, headers);
              } catch (e) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Error while extracting response event form XHR response', e);
              }

              if (original) {
                for (var _len4 = arguments.length, onloadendArgs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  onloadendArgs[_key4] = arguments[_key4];
                }

                return original.apply(xhr, onloadendArgs);
              }
            };
          });
          return originalOpen.apply(this, openArgs);
        };
      });
    }
    /**
     * Checks whether given url points to Sentry server
     *
     * @param url url to verify
     */

  }, {
    key: "_isSentryRequest",
    value: function _isSentryRequest(url) {
      var client = this._getCurrentHub && this._getCurrentHub().getClient();

      if (!client) {
        return false;
      }

      var dsn = client.getDsn();
      return dsn ? url.includes(dsn.host) : false;
    }
    /**
     * Checks whether to capture given response as an event
     *
     * @param status response status code
     * @param url response url
     */

  }, {
    key: "_shouldCaptureResponse",
    value: function _shouldCaptureResponse(status, url) {
      return this._isInGivenStatusRanges(status) && this._isInGivenRequestTargets(url) && !this._isSentryRequest(url);
    }
    /**
     * Creates a synthetic Sentry event from given response data
     *
     * @param data response data
     * @returns event
     */

  }, {
    key: "_createEvent",
    value: function _createEvent(data) {
      var message = "HTTP Client Error with status code: ".concat(data.status);
      var event = {
        message: message,
        exception: {
          values: [{
            type: 'Error',
            value: message
          }]
        },
        request: {
          url: data.url,
          method: data.method,
          headers: data.requestHeaders,
          cookies: data.requestCookies
        },
        contexts: {
          response: {
            status_code: data.status,
            headers: data.responseHeaders,
            cookies: data.responseCookies,
            body_size: this._getResponseSizeFromHeaders(data.responseHeaders)
          }
        }
      };
      addExceptionMechanism(event, {
        type: 'http.client'
      });
      return event;
    }
  }]);

  return HttpClient;
}();

HttpClient.__initStatic();

export { HttpClient };